import {
  ChartLine,
  ClipboardCheck,
  FileText,
  GraduationCap,
  House,
  LucideIcon,
  Settings,
  Shapes,
  SquarePen,
  Table,
} from 'lucide-react';

export interface PageCategory {
  label: string;
  to: string;
  icon: LucideIcon;
  navId?: string;
}

export const HOME: PageCategory = { label: 'Home', to: '/', icon: House };
export const PLANNING: PageCategory = { label: 'Planning', to: '/units', icon: SquarePen };
export const ASSIGNMENTS: PageCategory = { label: 'Assignments', to: '/assignments', icon: ClipboardCheck };
export const SKILL_CHALLENGES: PageCategory = { label: 'Skill Challenges', to: '/assessment-history', icon: Shapes };
export const CLASS_REPORTS: PageCategory = {
  label: 'Class Reports',
  to: '/progress',
  icon: ChartLine,
  navId: 'sideNavClassReport',
};
export const DATA_EXPORTS: PageCategory = { label: 'Data Exports', to: '/reports-hub', icon: FileText };

export const CLASSES_AND_PEOPLE: PageCategory = {
  label: 'Classes & People',
  to: '/classes-rosters',
  icon: GraduationCap,
};

export const SITE_SETTINGS: PageCategory = { label: 'Site Settings', to: '/settings', icon: Settings };
export const QUICK_DATA: PageCategory = { label: 'Quick Data', to: '/quick-data', icon: Table };

export const TEACHER_NAV_CATEGORIES: PageCategory[] = [
  HOME,
  PLANNING,
  ASSIGNMENTS,
  SKILL_CHALLENGES,
  CLASS_REPORTS,
  DATA_EXPORTS,
];

export const ADMIN_NAV_CATEGORIES: PageCategory[] = [
  HOME,
  CLASSES_AND_PEOPLE,
  CLASS_REPORTS,
  SKILL_CHALLENGES,
  PLANNING,
  ASSIGNMENTS,
  DATA_EXPORTS,
];
